export default __webpack_public_path__ + "static/media/IMG_4158.da85a057.jpg";